import React from 'react';
import { Button } from 'antd';
import { CopyOutlined } from '@ant-design/icons';
import { toast } from 'react-toastify';

export const createBarcodeCellRenderer = () => (barcode) => (
  <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', width: '100%' }}>
    <span style={{ color: '#000' }}>{barcode}</span>
    <div style={{ display: 'flex', gap: 8 }}>
      <Button
        type="link"
        onClick={() => {
          navigator.clipboard.writeText(barcode);
          toast.success('Codul de bare a fost copiat!');
        }}
        style={{ padding: 0, height: 'auto', lineHeight: 1 }}
      >
        <span
          style={{
            backgroundColor: 'gray',
            borderRadius: '50%',
            padding: '4px',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            width: '20px',
            height: '20px'
          }}
        >
          <CopyOutlined style={{ color: '#fff', fontSize: '14px' }} />
        </span>
      </Button>
    </div>
  </div>
);
